import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { updateUser } from "../actions/user"
import { openSnackbar } from "../actions/snackbar"
import { openPopup } from '../actions/popup'
import UserProfile from './UserProfile'
import md5 from "../lib/m_c_md5"
import { getRoleName } from '../lib/dictionary'

function ProfileEdit({ user, updateUser, openSnackbar, openPopup }) {
    let [email, setEmail] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Email || '')
    const [username, setUsername] = useState(user.data.name || '')
    const [pass, setPass] = useState(null)
    const [confirmPass, setConfirmPass] = useState(null)
    const [company, setCompany] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Company.value || '')
    const [inn, setInn] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.INN || '')
    let [phone, setPhone] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Phone || '')
    const [role, setRole] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.UserType.key || '')

    const [isCheckRequests, setCheckRequests] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.chkReq || false)
    const [isCheckComments, setCheckComments] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.chkComm || false)
    const [isAccessLPO, setIsAccessLPO] = useState(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.accessLPO || false);

    useEffect(() => {
        setRole(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.UserType.key)
        setEmail(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Email)
        setUsername(user.data.name)
        setCompany(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Company.value)
        setInn(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.INN)
        setPhone(user.data.object.ae9dd1b1032daaed7cc9638180dc6318b.Phone)
    }, [user])
    const isSpecLPO = role === 'b3940d35edbbb3d8204f1b820a87d8e12' ? true : false
    const textError = <p className="auth-label-required">Это обязательное поле</p>
    return (
        <form onSubmit={submitEdit} className='auth-editForm'>
            <label className="auth-label clr-white fs-14">Роль:</label>
            <select className='auth-select select--right' value={role} onChange={e => setRole(e.target.value)}>
                <option key={0} value='e249a07138dd45d3f4ba27d90d6c2244d'>Держатель сертификата FSC</option>
                <option key={1} value='b3940d35edbbb3d8204f1b820a87d8e12'>Специалист оцифровки актов ЛПО</option>
                <option key={2} value='a436a766765eabad209d971014b41999b'>Администратор оцифровки актов ЛПО</option>
                <option key={3} value='eeb43e3d0be1d6e8bb92aa704092f9df1'>Аудитор</option>
                <option key={4} value='f23d9209a63265defaeda6693d6f4b94d'>Наблюдатель</option>
            </select>

            <label className="auth-label clr-white fs-14 mt-8">E-mail:</label>
            <input autoComplete='off' name='email' value={email} className={`auth-input big ${email === '' ? 'error' : ''}`} type="text" onChange={(e) => setEmail(e.target.value)} required placeholder="Надо будет подтвердить" />
            {email === '' && textError}

            <label className="auth-label clr-white fs-14 mt-8">Новый пароль:</label>
            <input autoComplete='off' name='pass' className={`auth-input big`} type="password" onChange={(e) => setPass(e.target.value)} />

            <label className="auth-label clr-white fs-14 mt-8">Повторите пароль:</label>
            <input autoComplete='off' name='pass' className={`auth-input big`} type="password" onChange={(e) => setConfirmPass(e.target.value)} />

            <label className="auth-label clr-white fs-14 mt-8">Наименование юридического лица:</label>
            <input autoComplete='off' name='company' required={!isSpecLPO ? true : false} value={company} className={`auth-input big ${company === '' && !isSpecLPO ? 'error' : ''}`} type="text" onChange={(e) => setCompany(e.target.value)} placeholder={`Включая "ООО" и т.п.`} />
            {company === '' && !isSpecLPO && textError}

            <label className="auth-label clr-white fs-14 mt-8">ИНН:</label>
            <input autoComplete='off' name='inn' value={inn} className={`auth-input big ${inn === '' && !isSpecLPO ? 'error' : ''}`} type="text" onChange={(e) => setInn(e.target.value)} required={!isSpecLPO ? true : false} placeholder="Только цифры" />
            {inn === '' && !isSpecLPO && textError}

            <label className="auth-label clr-white fs-14 mt-8">Контактный телефон:</label>
            <input autoComplete='off' name='phone' value={phone} className="auth-input big" type="text" onChange={(e) => setPhone(e.target.value)} placeholder="Не будет виден другим" />

            <div style={{ marginTop: "4px" }}>
                <input onChange={e => setIsAccessLPO(e.currentTarget.checked)} className="custom-checkbox"
                       type="checkbox" id="accessLPO" checked={isAccessLPO}/>
                <label className="auth-label clr-white fs-14 mt-8" htmlFor="accessLPO">Доступен интерфейс работы с актами ЛПО</label>
            </div>

            <label className="auth-label clr-white fs-14 mt-8">Получать уведомления:</label>
            <input onChange={e => setCheckRequests(e.currentTarget.checked)} className="custom-checkbox" type="checkbox" id="new-requests" checked={isCheckRequests} />
            <label for="new-requests">О новых запросах</label>
            <input onChange={e => setCheckComments(e.currentTarget.checked)} className="custom-checkbox" type="checkbox" id="new-comments" checked={isCheckComments} />
            <label for="new-comments">О новых комментариях</label>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px' }}>
                <button className="auth-button" type="submit">Сохранить</button>
                <button className="auth-button" onClick={e => { e.preventDefault(); openPopup('Вы вошли как:', <UserProfile />) }}>Отмена</button>
            </div>

        </form>
    )

    function submitEdit(e) {
        e.preventDefault()
        phone = phone.trim()
        email = email && email.toLowerCase()
        new Promise((resolve) => {
            if (/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/.test(email)) return resolve()
            else throw new Error("Неверный формат электронной почты")
        }).then(() => {
            if (username.length <= 100) return true
            else throw new Error("Никнейм должен содержать не более 100 символов")
        }).then(() => {
            if (!inn && isSpecLPO) return true
            else if (inn.length <= 12 && inn.length >= 10 && /^[0-9]+$/.test(inn)) return true
            else throw new Error("ИНН должен содержать только цифры, от 10 до 12 символов")
        }).then(() => {
            if (!phone || (phone.length <= 12 && /^((8|\+7)[- ]?)?(\(?\d{3}\)?[- ]?)?[\d\- ]{7,10}$/.test(phone))) return true
            else throw new Error("Неверный формат номера телефона")
        }).then(() => {
            if ((pass && confirmPass) || (pass === confirmPass)) return true
            else throw new Error("Пароли не совпадают")
        }).then(() => {
            const new_user = JSON.parse(JSON.stringify(user.data))
            if (pass) {
                const c2index = user.data.object.c2.findIndex(i => i.oParTextboxUser.PrmTe1.key === "Pass")
                const newPass = md5(pass)
                new_user.object.c2[c2index].oParTextboxUser.PrmTe3.value = newPass
            }
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.UserType.key = role
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.UserType.value = getRoleName(role)
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.Email = email
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.Company = { value: company }
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.INN = inn
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.Phone = phone
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.chkReq = isCheckRequests;
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.chkComm = isCheckComments;
            new_user.object.ae9dd1b1032daaed7cc9638180dc6318b.accessLPO = isAccessLPO;
            new_user.system.oProperty.name = username
            updateUser(new_user, pass)
        }).catch(error => openSnackbar(error.message, "error"))
    }
}

const mapStateToProps = state => ({
    user: state.user
})

export default connect(mapStateToProps, { updateUser, openSnackbar, openPopup })(ProfileEdit)